module.exports = __webpack_public_path__ + "static/media/instagram.f1a4f500.svg";